import React from 'react'
import { useSelector } from 'react-redux'
import DemographicsCharts from 'features/DemographicsCharts'
import { isAskMdtAvailable } from 'features/AskMdt'
import { AreaNarrativePanel } from 'features/AskMdt/components/AreaNarrativePanel'
import { useParams } from 'react-router-dom'

const LocationDemographics = () => {
	const { id } = useParams()
	const { location, loading } = useSelector(state => {
		return {
			loading: state.locations.isLoading,
			success: state.locations.isInitialized,
			location: state.locations.entities[id],
		}
	})
	const askAvailable = isAskMdtAvailable(useSelector(state => state.userLogin?.userInfo))

	// TODO - should put a warning that they need lat/long to have this page populate
	if (loading || !location || !location.longitude || !location.latitude) return null
	return (
		<>
			{askAvailable && <AreaNarrativePanel anchorType="Location" anchorId={id} className="mb-4" />}
			<DemographicsCharts asset={location} />
		</>
	)
}

export default LocationDemographics
